var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import Card from "../../atoms/card/card";
import NavBar from "../../organisms/navBar/navBar";
import PageHeader from "../../organisms/pageHeader/pageHeader";
import Button from "../../atoms/button/button";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import showPopupModal from "../../../redux/actions/popupModal";
import InviteTeamMember from "../../organisms/inviteTeamMember/InviteTeamMember";
import { getCaseloads } from "../../../redux/actions/manage_users";
import { getProfileData } from "../../../redux/actions/profile";
import PendingInvites from "../../organisms/pendingInvites/PendingInvites";
import "../../templates/general_page_template.css";
export default function Accounts() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var state = useLocation().state;
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    var profileLoaded = useSelector(function (state) { return state.rootReducer.profileReducer.id; });
    var orgId = useSelector(function (state) { return state.rootReducer.profileReducer.id; });
    var username = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_username; });
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    var viewing_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_user_type; });
    var caseload = useSelector(function (state) { return state.rootReducer.ManageUserReducer.caseload; });
    // Determine which user we're viewing
    var currentViewingUser = viewing_username || username;
    // Fetch caseload for the viewing user (or logged-in user if not viewing another)
    useEffect(function () {
        if (currentViewingUser) {
            dispatch(getCaseloads(currentViewingUser));
        }
    }, [currentViewingUser, dispatch]);
    useEffect(function () {
        if (!orgId && username) {
            dispatch(getProfileData());
        }
    }, [orgId, username, dispatch]);
    // Get team members from the caseload
    var getTeamMembers = function () {
        if (!caseload) {
            return [];
        }
        var members = caseload.team_members || [];
        return members;
    };
    var formatDate = function (dateString) {
        try {
            var date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
        }
        catch (_a) {
            return dateString || "—";
        }
    };
    var getRoleLabel = function (role) {
        return role === "admin" ? "Admin" : "Member";
    };
    var getRoleStyle = function (role) {
        return role === "admin"
            ? "bg-purple-100 text-purple-800"
            : "bg-blue-100 text-blue-800";
    };
    var isCurrentUser = function (memberName) {
        // Compare with viewing user, or with logged-in user if not viewing another
        var userToCompare = viewing_username || username;
        return memberName === userToCompare;
    };
    var isCurrentUserAdmin = function () {
        var members = getTeamMembers();
        var currentUserMember = members.find(function (member) { return isCurrentUser(member.name); });
        return (currentUserMember === null || currentUserMember === void 0 ? void 0 : currentUserMember.role) === "admin";
    };
    var teamMembers = getTeamMembers();
    return (_jsxs("div", __assign({ className: "h-full" }, { children: [_jsx(NavBar, { viewing_user: viewing_user_type || logged_in_user_type, logged_in_user: logged_in_user_type, viewing_username: viewing_username || username }), _jsxs("div", __assign({ className: "page-template-right", style: { position: "relative" } }, { children: [viewing_username && viewing_username !== username ? (_jsx(PageHeader, { title: "Accounts", backButton: "Back to Your Dashboard", onClick: function () {
                            navigate("/dashboard", {
                                state: { state: { viewUser: username } },
                            });
                        } })) : (_jsx(PageHeader, { title: "Accounts" })), _jsxs(Card, __assign({ multiLine: true, className: "!pt-4" }, { children: [_jsxs("div", __assign({ className: "mb-6 flex justify-between items-center" }, { children: [_jsx("h2", __assign({ className: "text-xl font-semibold" }, { children: "Members" })), (!viewing_username || viewing_username === username) && isCurrentUserAdmin() && (_jsx(Button, __assign({ onClick: function () {
                                            dispatch(showPopupModal(true, _jsx(InviteTeamMember, {})));
                                        }, className: "px-4 py-2 text-sm" }, { children: "Invite Member" })))] })), teamMembers.length === 0 ? (_jsx("div", __assign({ className: "py-8 text-center text-gray-500" }, { children: _jsx("p", { children: "No members yet. Start by inviting someone to your team." }) }))) : (_jsx("div", __assign({ className: "overflow-x-auto" }, { children: _jsxs("table", __assign({ className: "w-full text-left" }, { children: [_jsx("thead", { children: _jsxs("tr", __assign({ className: "border-b border-gray-200" }, { children: [_jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Name" })), _jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Email" })), _jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Date Joined" })), _jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Role" }))] })) }), _jsx("tbody", { children: teamMembers.map(function (member, index) { return (_jsxs("tr", __assign({ className: "border-b border-gray-100 ".concat(isCurrentUser(member.name)
                                                    ? "bg-blue-50"
                                                    : "hover:bg-gray-50") }, { children: [_jsx("td", __assign({ className: "py-3" }, { children: _jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [member.name, isCurrentUser(member.name) && (_jsx("span", __assign({ className: "text-xs font-semibold px-2 py-1 rounded-full bg-blue-100 text-blue-700" }, { children: "You" })))] })) })), _jsx("td", __assign({ className: "py-3" }, { children: member.email || "—" })), _jsx("td", __assign({ className: "py-3" }, { children: formatDate(member.dateJoined) })), _jsx("td", __assign({ className: "py-3" }, { children: _jsx("span", __assign({ className: "px-3 py-1 rounded-full text-sm ".concat(getRoleStyle(member.role)) }, { children: getRoleLabel(member.role) })) }))] }), index)); }) })] })) })))] })), (!viewing_username || viewing_username === username) && isCurrentUserAdmin() && (_jsx(PendingInvites, { orgId: orgId, userType: logged_in_user_type, enabled: !!orgId }))] }))] })));
}
